import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Lightbox from 'react-images'
import { LinkExternal } from 'Components/LinkExternal'

export class ModalLightbox extends Component {
  state = { isOpen: false }

  closeLightbox = () => this.setState({ isOpen: false })
  openLightbox = () => this.setState({ isOpen: true })

  render() {
    const { linkText, image } = this.props
    return (
      <div cypress_id={this.props.cypress_id}>
        <LinkExternal href="#" className="view-map" onClick={this.openLightbox}>
          {linkText}
        </LinkExternal>
        <Lightbox
          images={[{ src: image }]}
          isOpen={this.state.isOpen}
          onClose={this.closeLightbox}
        />
      </div>
    )
  }
}

ModalLightbox.propTypes = {
  linkText: PropTypes.string,
  image: PropTypes.string,
}
